module.exports = __webpack_public_path__ + "img/IMG_7019.d960f057.webp";